// extracted by mini-css-extract-plugin
module.exports = {"container":"collection-details_container__36_E4","content":"collection-details_content__2suA2"};